import { useState, useEffect } from 'react';

import {
  useSearchParamState,
  serializationOptionsForStringValue,
} from 'utils/hooks/useSearchParamState';
import { EventInfo } from '../../../domain';
import { EventHistoryNameCell } from './columns/EventHistoryNameCell';
import { EventHistoryDetailCell } from './columns/EventHistoryDetailCell';
import { EventHistoryOverflowMenuCell } from './columns/EventHistoryOverflowMenuCell';
import { EventHistoryTimeCell } from './columns/EventHistoryTimeCell';
import { EventHistoryUserAgentCell } from './columns/EventHistoryUserAgentCell';
import { CollapsibleJsonView } from './columns/CollapsibleJsonView';
import { Row } from '../../../components/table';

interface EventHistoryRowProps {
  event: EventInfo;
  index: number;
}

export const EventHistoryRow = ({ event, index }: EventHistoryRowProps) => {
  const [isCollapsed, setCollapsed] = useState(true);
  const [recentEvent, setRecentEvent] = useSearchParamState({
    searchParamKey: 'createdAt',
    stateValueWhenSearchParamIsUnset: '',
    ...serializationOptionsForStringValue,
  });
  const isRecentEvent = recentEvent === event.createdAt;

  useEffect(() => {
    if (isRecentEvent) {
      setCollapsed(!isCollapsed);
    }
  }, [isRecentEvent]);

  const setCollapsedWrapped = (collapsed: boolean) => {
    setCollapsed(collapsed);
    if (collapsed) setRecentEvent('');
  };

  return (
    <Row index={index}>
      <EventHistoryNameCell
        userEvent={event}
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setCollapsedWrapped(!isCollapsed)}
      />
      <EventHistoryDetailCell userEvent={event} />
      <EventHistoryUserAgentCell userEvent={event} />
      <EventHistoryTimeCell userEvent={event} />
      <EventHistoryOverflowMenuCell event={event} />
      <CollapsibleJsonView event={event} isCollapsed={isCollapsed} />
    </Row>
  );
};
